import React from 'react';
import {Image} from 'react-bootstrap';
import {Icon} from 'shared/helpers';

interface CBCImageProp {
    src: string;
    alt?: string;
    color?: string;
    id?: string;
    title?: string;
    className?: string;
    style?: React.CSSProperties;
    localDirectory?: boolean;
}

// Assumes that all the icons are inside assets/images/icons directory
export const CBCImage = ({src, ...props}: CBCImageProp) => {
    const {localDirectory, ...imageProps} = props;

    if (typeof src !== 'undefined' && src !== '') {
        const imageNameParts: Array<string> = src.split('.');
        if (imageNameParts.pop() === 'svg') {
            return (
                <Icon
                    {...imageProps}
                    localDirectory={localDirectory}
                    iconName={src}
                />
            );
        } else {
            return <Image {...imageProps} src={src} />;
        }
    } else {
        return null;
    }
};
